function PayoutListService(ApiService) {
    'ngInject';
    const service = {};

    service.getOrganizations = function(search, callbackFunc) {
        ApiService.get(`/organizations/all_organizations.json?by_organization_name = ${search}`, callbackFunc);
    };

    service.getPayoutMappings = function(orgId, url, pageNumber, size, callbackFunc) {
        ApiService.get(url, callbackFunc);
    };

    service.editPayoutMapping = function(mappingFrom, orgId, id, callbackFunc) {
        ApiService.put(`/organizations/${orgId}/amazon_payout_mappings/${id}.json`, mappingFrom, callbackFunc);;
    };

    service.deletePayoutMapping = function(orgId, id, callbackFunc) {
        ApiService.delete(`/organizations/${orgId}/amazon_payout_mappings/${id}.json`, {}, callbackFunc);
    };

    service.savePayoutMapping = function(mappingFrom, orgId, callbackFunc) {
        ApiService.post(`/organizations/${orgId}/amazon_payout_mappings.json`, mappingFrom, callbackFunc);
    };

    service.importMappings = function(fromId, mappingIds ,orgId, callbackFunc) {
        ApiService.post(`/organizations/${orgId}/amazon_payout_mappings/import_mappings.json`, { from_organization: fromId , mapping_ids: mappingIds}, callbackFunc);
    };

    return service;
}

export default {
    name: 'PayoutListService',
    fn: PayoutListService
}
